import React, { useEffect, useMemo, useState } from "react";
import AdminHeading from "../Heading/AdminHeading";
import ListTable from "Components/CommonComponents/ListTable";
import { ClipLoader } from "react-spinners";
import ErrorModal from "Components/Other Functions/popup";
import AlertMessage from "Components/Other Functions/AlertMessage";
import { useSelector } from "react-redux";
import GetApiService from "Components/Api/getapiService";
import { useMutation, useQuery } from "@tanstack/react-query";
import { Link, useNavigate } from "react-router-dom";
import { a188, a730 } from "Components/Api/RootApiPath";
import { Add } from "@mui/icons-material";
import CustomerTable from "Components/support/customervendor/customer";
import { Icon } from "@iconify/react";
import { invoiceListColumns, purchaseListColumns, schemeInstallmentListColumns } from "utils/helpers";
import { fetchInvoice, fetchInvoiceList } from "services/invoiceServices";
import PageLoader from "Components/PageLoader";
import { generateBillPDF } from "Components/Other Functions/GenerateBillPDF";
import useScreenSize from "hooks/useScreenSize";
import AdminBreadCrump from "../Heading/AdminBreadCrump";

const SchemeInstallmentList = () => {
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const allStates = useSelector((state) => state);
  const navigate = useNavigate();
  const adminLoggedIn = allStates.reducer1;
  const clientCode = adminLoggedIn.ClientCode;
  const apiService = new GetApiService(clientCode);
  const InvoiceFormat = parseInt((adminLoggedIn?.Clients?.InvoiceFormat ));
  const isSmallScreen = useScreenSize();
  const [searchInput, setSearchInput] = useState("");

  const {
    data: InvoiceList,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["invoice/getInvoiceList", clientCode],
    queryFn: fetchInvoiceList,
    refetchOnWindowFocus: false,
    // cacheTime: 1000 * 60 * 2,
    // staleTime: 1000 * 60 * 2,
  });
  const {data:Invoice,isError:InvoiceIsError,isLoading:InvoiceIsLoading,error:InvoiceError,mutate} = useMutation({mutationFn:fetchInvoice});

   const invoiceList = useMemo(()=>{
      const formattedData = InvoiceList?.length ? InvoiceList.map((item, index) => ({
        // serialNumber: index + 1,  // If you need a sequential ID
        ...item,
        CustomerId:item?.Customer?.FirstName,
        GrossWt:(+(item?.NetWt || 0))?.toFixed(3),
        NetWt:(+(item?.NetWt || 0))?.toFixed(3),

      })) : [];
      return formattedData
    },[InvoiceList])

  const handleEditData = (product) => {
    navigate(`/edit_invoice_new/${product?.Id}`);
  };
  const columns = [
    { key: "Id", label: "Id" },
    { key: "InvoiceNo", label: "Invoice Number" },
    { key: "InvoiceDate", label: "Invoice Date" },
    { key: "InvoiceStatus", label: "Invoice Status" },
    { key: "FirstName", label: "Name" },
    { key: "CustomerId", label: "Customer Id" },
  ];


  useEffect(()=>{
    if(Invoice){
      generateBillPDF(
        Invoice?.InvoiceItem,
        Invoice?.Customer,
        InvoiceFormat,
        Invoice,
        adminLoggedIn,
        isSmallScreen
      )
    }
  },[Invoice])

  const handlePrint =(product)=>{
    console.log(product)
    mutate({ id: product?.Id, clientCode: product?.ClientCode });
    
  }
  console.log(InvoiceList)
  return (
    <>
      <div>
        <AdminHeading />
        {isLoading || InvoiceIsLoading && <PageLoader />}
        {loading ? (
          // Show spinner while loading
          <div className="spinner-container">
            <ClipLoader size={50} color={"#123abc"} loading={loading} />
            <p>Loading data...</p>
          </div>
        ) : (
          <>
            <div>
              <ErrorModal
                isOpen={showModal}
                onRequestClose={() => {
                  setShowModal(false); // Close the modal
                  navigate("/adminhome"); // Redirect to /adminhome
                }}
                onReload={() => {}} // Pass reload function
                message={errorMessage}
              />

              <div className="adminMainBodyBox">
                {showError ? (
                  <AlertMessage message={messageToShow} type={messageType} />
                ) : null}
              </div>
            </div>
          </>
        )}
         {
                  isSmallScreen ? (
                    ''
                  ) : (
                    <AdminBreadCrump
                    title={`${"Scheme Installment List"}`}
                    companyName={"Loyalstring"}
                    module={"Gold Scheme"}
                    page={`${"Scheme Installment List"}`}
                  />
                  )
                }
               
      </div>
      {/* <div style={{padding:"5px 20px"}}>
     <div style={{display:'flex',justifyContent:'end'}}>
      
      <Link to={`/invoice_entry_new`} style={{textDecoration:"none",display:'flex',justifyContent:'center',alignItems:'center',gap:"4px",cursor:'pointer',color:"#fff",background:"#0077d4",borderRadius:'5px',padding:"4px 10px"}} >Add <Add/></Link>

    
     </div>
      <ListTable
      columns={columns}
      handleEditData={handleEditData}
      data={InvoiceList?.length ? [...InvoiceList].reverse( ) : []}
      />
      </div> */}

      <div>
        <div
          style={{
            display: "flex",
            gap: "20px",
            display: "flex",
            justifyContent: "end",
            background: "#fff",
            padding: "10px 0px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <input
              type="text"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
              placeholder="Search..."
              style={{
                border: "1px solid gray",
                borderRadius: "0px",
                borderBottomLeftRadius: "8px",
                borderTopLeftRadius: "8px",
                height: '100%'
              }}
              // className={style["serach-input"]}
            />

            <Icon
              style={{
                fontSize: "20px",
                padding: "7px",
                background: "#0077D4",
                color: "#fff",
                height: "20px",
                width: "20px",
                borderBottomRightRadius: "8px",
                borderTopRightRadius: "8px",
              }}
              icon="mdi:magnify"
            />
          </div>

          {/* <Icon
            style={{
              fontSize: "28px ",
              color: "#0077d4",
              cursor: "pointer",
            }}
            icon="bx:export"
          /> */}

          {/* <button
          // style={{ width: "30%" }}
          // className={style["custom-btn"]}
          >
            <Icon style={{ fontSize: "24px " }} icon="ic:outline-print" />
            Print
          </button> */}
          <button
            //  onClick={handlenew}
            onClick={() => navigate("/credit_note_new")}
            style={{ margin: 0 }}
            // className={style["custom-btn"]}
          >
            New
            <Icon icon="mdi:plus" width="24" height="24" />
          </button>
        </div>

        <CustomerTable
          columns={schemeInstallmentListColumns}
          allCategories={[]}
          handleEditData={(product) =>
            navigate(`/edit_invoice_new/${product?.Id}`)
          }
          handlePrint={(product)=>handlePrint(product)}
          searchInput={searchInput}
          setSearchInput={setSearchInput}

          // title={"All Customers"}
        />
      </div>
    </>
  );
};

export default SchemeInstallmentList;
